import React from "react";
import FormTextTC from "../../../components/Forms/FormTextTC";

function Gifty() {
  return (
    <>
      <FormTextTC
        name={"pay_provider_sec__gifty__location_id"}
        tDefault={"locatie id"}
        tKey={"form.primairbetallingsverkeer.label.pay_provider_sec__gifty_location_id"}
      />
      <FormTextTC
        name={"pay_provider_sec__gifty__apiKey"}
        tDefault={"apikey"}
        tKey={"form.primairbetallingsverkeer.label.pay_provider_sec__gifty__apiKey"}
      />
    </>
  );
}

export default Gifty;
